import React from 'react';
import './squre.scss';
import propTypes from 'prop-types';

const Squre = (props) => {
  const { width, height, className } = props;

  return (
    <div
      className={`squre-skeleton-container ${className}`}
      style={{ width, height }}
    >
      <div className="squre-skeleton"></div>
    </div>
  );
};

Squre.propTypes = {
  width: propTypes.string,
  height: propTypes.string,
};
Squre.defaultProps = {
  width: '80px',
  height: '80px',
  className: '',
};

export default Squre;
